import React from 'react';
import Header from '../components/layout/header';

import Footerr from '../components/layout/footer';
import { useState } from 'react';
import Preloader from '../components/common/preloader';
import Sec1about from '../sections/sec1-about';
import Sec2about from '../sections/sec2-about';
import Sec3about from '../sections/sec3-about';



const About = () => {
    
            const [loading, setLoading] = useState(true);
    return ( 
        <>
                         {loading && <Preloader onFinish={() => setLoading(false)} />}
            <main className='body-bg'>
                <Header />
                <Sec1about  loading={loading}/>
                <Sec2about />
                <Sec3about />

            </main>
            <Footerr />
        </>
     );
}
 
export default About;